import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal.service';
import moment from 'moment';

@Component({
    selector: 'app-timeline-transport-vor-and-absence',
    templateUrl: './timeline-transport-vor-and-absence.component.html',
    styleUrls: ['./timeline-transport-vor-and-absence.component.scss'],
    standalone: false
})
export class TimelineTransportVorAndAbsenceComponent implements OnInit {
  @Input()
  record: any = null;

  @Input()
  type: string = '';

  @Output()
  closed: EventEmitter<void> = new EventEmitter();

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
  }

  close() {
    this.modalService.close('vorAbsenceInfoModal');
    this.closed.emit();
  }

  getAbsenceEnd(date) {
    return moment(date).add(1, 'day').format('DD/MM/YY');
  }

}
